import { getSerializeCommonQuery, cacheApi } from '@lib/utils.js';
import { GET, POST, fetchData } from '@service/bridge';
import axios from '@lib/axios';

// 获取KConf配置信息
export async function getKconfData(params) {
    const { data } = await axios.get(`/api/internal/kconf`, { params });
    return data;
};

// 通过用户ID查用户信息
export const getBasicUserInfoByUserId = GET`/hey-server/api/v4/user/findByUid`;
// 通过回森号获取用户信息
export const getBasicUserInfoByShowId = GET`/hey-server/api/v4/user/findByShowId`;

// 获取k歌群列表
export const getGroupList = GET`/hey-server/api/v3/kara/groups`;

// 加群
export const joinGroup = GET`/hey-server/api/v3/kara/joinGroup`;

// 获取用户信息
export const getUserInfo = GET`/hey-server/api/v1/user/profile`;

// 获取标签列表
export const getLabelList = GET`/hey-server/api/v1/user/tags/listAll`;

// 更新用户标签
export const updateLabel = POST`/hey-server/api/v1/user/tags/update`;

// 获取成就挂件列表
export const getAchievementList = GET`/hey-server/api/v3/medal/achievements`;

// 佩戴成就挂件
export const wearAchievement = POST`/hey-server/api/v3/medal/wear`;

// 取消成就挂件
export const takeOffAchievement = POST`/hey-server/api/v3/medal/takeOff`;

// 唱诗活动页面获取歌单信息
export const getMusiList = GET`/hey-server/api/v1/h5Activity/national2021/musicGroups`;

// 厉害了我的国活动获取信息
export const getNationalDayInfo = GET`/hey-server/api/v1/h5Activity/national2021/markMap/progress`;

// 厉害了我的国活动抽奖
export const drawLottery = GET`/hey-server/api/v1/h5Activity/national2021/markMap/drawLottery`;

// 十一接龙活动获取歌单信息
export const getMusicList20211001 = GET`/hey-server/api/v1/h5Activity/national2021/jielong/musics`;

// 十一接龙活动用户排行榜
export const getUserList20211001 = GET`/hey-server/api/v1/h5Activity/national2021/jielong/rankBoard`;

// 当前用户信息导出状态
export const getDumpState = GET`/hey-server/api/v1/user/profileDumpState`;

// 导出用户信息
export const handleDumpProfile = GET`/hey-server/api/v1/user/dumpProfile`;

// 获取最近七天的接龙作品榜单
export const getVoiceRankList = cacheApi('get-voice-rank-list')((params = {}) => fetchData({
    method: 'GET',
    urlString: '/hey-server/api/v1/sequenced/voice/rank',
    data: {
        ...params,
    },
}));

// 获取配音专区信息
export const getDubAreaInfo = GET`/hey-server/api/v1/h5Activity/peiyin/musics`;

// 获取配音专区收藏列表
export const getDubAreaCollect = GET`/hey-server/api/v1/h5Activity/peiyin/musics/collect/list`;

// 设置配音专区item收藏状态
export const postDubareaCollectStatus = POST`/hey-server/api/v1/h5Activity/peiyin/musics/collect`;

// 获取金币历史明细
export const getCoinHistoryDetail = GET`/hey-server/api/v3/gift/coinHistory`;

// 获取钻石历史明细
export const getDiamondHistoryDetail = GET`/hey-server/api/v3/gift/diamondHistory`;

// 金礼值兑换金币
export const postCoinGiftExchangeCoin = POST`/hey-server/api/v4/gift/exchangeCoins`;

// 旧版钻礼值兑换钻石
export const postOldDiamondGiftExchangeCoin = POST`/hey-server/api/v4/gift/exchangeDiamonds`;

// 钻礼值兑换钻石
export const postDiamondGiftExchangeCoin = POST`/hey-server/api/v4/wallet/exchangeDiamonds`;

// 钻礼值兑换试算
export const postDiamondGiftExchangeTrial = POST`/hey-server/api/v4/wallet/trialExchange`;

// 实名认证
export const getRealNameVerifyStatus = GET`/hey-server/api/v4/identity/getVerifyInfo`;

// 提现历史
export const getWithdrawHistoryList = GET`/hey-server/api/v4/wallet/withdrawHistory`;

// 获取任务中心信息
export const getTaskInfo = GET`/hey-server/api/v3/gift/taskCenter`;

// 获取金币礼物历史
export const getCoinGiftHistory = GET`/hey-server/api/v4/gift/coinGiftHistory`;

// 获取钻石礼物历史
// export const getDiamondGiftHistory = GET`/hey-server/api/v4/gift/diamondGiftHistory`;
export const getDiamondGiftHistory = GET`/hey-server/api/v4/gift/incomeHistory`;

// 申请提现
export const postApplyWithdraw = POST`/hey-server/api/v4/wallet/applyWithdraw`;

// 任务中心签到
export const signInTask = GET`/hey-server/api/v3/gift/getLoginReward`;

/**
 * 裂变钻石任务活动进度查询
 */
export const getInviteProcess = GET`/hey-server/api/v1/cronus/process`;

// 邀请任务分享文案
export const getInviteTaskShareText = GET`/hey-server/api/v2/cronus/share/text`;

// 获取礼物日榜
export const getTodayGiftBoard = GET`/hey-server/api/v3/board/todayGiftBoard`;

// 获取礼物周榜
export const getWeekGiftBoard = GET`/hey-server/api/v3/board/weekGiftBoard`;

// 获取收听日榜
export const getTodayPlayBoard = GET`/hey-server/api/v3/board/todayPlayBoard`;

// 获取收听周榜
export const getWeekPlayBoard = GET`/hey-server/api/v3/board/weekPlayBoard`;

// 获取土豪日榜
export const getTodayCoinBoard = GET`/hey-server/api/v3/board/todayTuhaoBoard`;

// 获取土豪周榜
export const getWeekCoinBoard = GET`/hey-server/api/v3/board/weekTuhaoBoard`;

// 获取用户资产
export const getItemInfo = GET`/hey-server/api/v4/assets/info`;

// 购买商品
export const postBuyItem = POST`/hey-server/api/v4/assets/buy`;

/**
 * 举报
 */
// 通用举报
export const report = POST`/hey-server/api/v1/h5/expose/submit`;
// 举报歌房
export const reportRoom = POST`/hey-server/api/v3/room/room/feedback/reportRoom`;
// 举报歌房用户
export const reportUser = POST`/hey-server/api/v3/room/room/feedback/reportUser`;
// 大众评审举报
export const publicAuditReport = POST`/hey-server/api/v3/public/audit/expose/result`;
// 获取视频列表
export const getUserWorkList = GET`/hey-server/api/v1/h5/expose/video/list`;
// 获取动态列表
export const getUserMomentList = GET`/hey-server/api/v1/h5/expose/moment/list`;

/**
 * 获取通用上传token
 */
export const createToken = GET`/hey-server/api/v1/user/uploadBatch/createToken`;

/**
 * 房间运营数据（包含房间运营中心内容）
 */
export const getRoomOpeartionData = GET`/room-server/api/v3/room/room/getRoomStatInfo`;

/**
 * 房间运营中心
 */
export const getRoomOpeartionInfo = GET`/room-server/api/v3/room/room/getRoomOperatorCenter`;
// 获取天团广场-正在招募的团
export const getOpenGroupList = GET`/hey-server/api/v3/band/recruitingBands`;
// 获取天团广场-热门的团
export const getHotGroupList = GET`/hey-server/api/v3/band/hotBands`;
// 申请加团
export const postJoinGroup = POST`/hey-server/api/v3/band/applyJoin`;
// 检测是否允许创建天团
export const postCheckCreatePermission = GET`/hey-server/api/v3/band/checkCreatePermission`;
// 获取天团信息
export const getBandInfo = GET`/hey-server/api/v3/band/getBandInfo`;

// 获取钻石充值信息
export const getDiamondGoods = GET`/hey-server/api/v4/gift/diamondMarket`;
// 使用物品
export const wearItem = POST`/hey-server/api/v4/assets/wear`;
// 取消使用物品
export const takeOffItem = POST`/hey-server/api/v4/assets/takeOff`;
// 天团任务
export const getGroupTaskList = GET`/hey-server/api/v3/band/level/tasks`;
// 天团标签
export const getGroupTagList = GET`/hey-server/api/v3/band/tags`;
// vip信息
export const getVIPInfo = GET`/hey-server/api/v3/vip/info`;

/**
 * 未成年退款
 */
// 提交退款申请
export const submitRefundApply = POST`/hey-server/api/v1/user/refund/apply/info/submit`;
// 修改退款申请
export const updateRefundApply = POST`/hey-server/api/v1/user/refund/apply/info/update`;
// 获取退款申请信息
export const getRefundApplyInfo = GET`/hey-server/api/v1/user/refund/apply/info`;
// 结束资源上传
export const finishRefundApplyUpload = GET`/hey-server/api/v1/user/refund/resource/upload/finish`;

// 获取自己的实名信息
export const getRealNameInfo = GET`/hey-server/api/v4/identity/realNameInfo`;
// 解除消费限制申请
export const postSubmitExpendApply = POST`/hey-server/api/v4/identity/submitExpendApply`;

/**
 * 签约
 */
// 签约状态
export const getContractStatus = GET`/hey-server/api/v3/room/contract/status`;
// 同意签约入驻
export const postContractAccept = POST`/hey-server/api/v3/room/contract/invite/accept`;
// 拒绝签约
export const postContractReject = POST`/hey-server/api/v3/room/contract/invite/reject`;

// 旧版签约日报 旧版整体预期2025.11.25删除代码
export const getContractDayReport = GET`/hey-server/api/v3/room/contract/report/day`;
// 旧版签约周报
export const getContractWeekReport = GET`/hey-server/api/v3/room/contract/report/week`;

// 新版签约日报概览
export const getContractDayReportSummary = GET`/room-server/api/v3/room/report/day/summary`;
// 新版签约日报详情
export const getContractDayReportDetail = GET`/room-server/api/v3/room/report/day/detail`;
// 新版签约周报概览
export const getContractWeekReportSummary = GET`/room-server/api/v3/room/report/week/summary`;
// 新版签约周报详情
export const getContractWeekReportDetail = GET`/room-server/api/v3/room/report/week/detail`;

// 签约云账户
export const postAcceptCloudAccount = POST`/hey-server/api/v4/account/acceptCloudAccount`;
// 解约云账户
export const postTerminateCloudAccount = POST`/hey-server/api/v4/account/terminateCloudAccount`;

// 基础分成比例调整信息
export const getGroupGotIncomeRatioChangeInfo = GET`/hey-server/api/v3/room/contract/member/groupGotIncomeRatio/changeInfo`;
// 接受调整
export const postAcceptGroupGotIncomeRatioChange = POST`/hey-server/api/v3/room/contract/member/groupGotIncomeRatio/acceptChange`;
// 拒绝调整
export const postRejectGroupGotIncomeRatioChange = POST`/hey-server/api/v3/room/contract/member/groupGotIncomeRatio/rejectChange`;

/**
 * 公会
 */
// 202310 新获取公会当期数据概览
export const getGuildSummary = GET`/hey-server/api/v3/contract/h5/group/stat/summary`;
// 新获取公会成员最近数据
export const getGuildMemberData = GET`/hey-server/api/v3/contract/h5/group/member/activeInfo`;
// 新获取公会当期任务完成情况
export const getGuildMemberTaskInfo = GET`/hey-server/api/v3/contract/h5/group/member/taskInfo`;
// 新获取签约公会历史任务完成情况
export const getGuildTaskHistory = GET`/hey-server/api/v3/contract/h5/group/stat/history`;
// 新公会会长提报主播
export const postGuildMemberSubmit = POST`/hey-server/api/v3/contract/h5/group/member/submit`;
// 新一键开播提醒
export const postAlertLive = POST`/hey-server/api/v3/contract/h5/group/member/live/alert`;
// 校验用户是否占用名额
export const getCheckQuota = GET`/hey-server/api/v3/contract/h5/group/candidate/checkQuota`;

/**
 * 新任务
 */
// 新任务信息
export const getNewTaskInfo = GET`/hey-server/api/v1/task/center/taskPage`;
// 新每日签到
export const newSignInTask = GET`/hey-server/api/v1/task/center/signIn`;
// 开宝箱
export const openActiveChest = POST`/hey-server/api/v1/task/center/openBox`;
// 曝光礼物赠送历史记录
export const getExposureGiftHistory = GET`/hey-server/api/v3/gift/trafficSendHistory`;

/**
 * 亲密空间
 */
// 获取亲密空间信息
export const getRelationSpaceInfo = GET`/hey-server/api/v1/companion/space`;
// 获取亲密关系任务列表
export const getRelationSpaceTask = GET`/hey-server/api/v1/companion/task`;
// 发送祝福
export const postRelationSpaceWish = POST`/hey-server/api/v1/companion/wish/send`;
// 获取关系更多操作相关信息
export const getRelationMoreOprationInfo = GET`/hey-server/api/v1/companion/op/config`;
// 更新关系隐私状态
export const postRelationPrivacyStatus = POST`/hey-server/api/v1/companion/updatePrivacy`;
// 解散关系
export const postDismissRelation = POST`/hey-server/api/v1/companion/dismiss`;
// 获取变更关系相关信息
export const getRelationChangeOprationInfo = GET`/hey-server/api/v1/companion/changeType/config`;
// 发起变更关系申请
export const postChangeRelation = POST`/hey-server/api/v1/companion/changeType/apply`;
// 升级信物
export const postUpgradeKeepsake = POST`/hey-server/api/v1/companion/upgradeKeepsake`;
// 更新崽崽隐私状态
export const postUpdateZaizaiPrivacy = POST`/hey-server/api/v1/companion/updateZaizaiPrivacy`;

// 获取新版亲密空间
export const getNewRelationSpaceInfo = GET`/hey-server/api/v1/companion/honeySpace`;
// 打开指定权益
export const postOpenBenefit = POST`/hey-server/api/v1/companion/benefit/open`;
// 关闭指定权益
export const postCloseBenefit = POST`/hey-server/api/v1/companion/benefit/close`;
// 发送私信表情预检查
export const postEmotionSendCheck = POST`/hey-server/api/v1/companion/emotion/sendCheck`;

/**
 * 申诉
 */
// 获取申诉信息
export async function getAppealInfo(params) {
    const {data} = await axios.get(`/hey-server/api/v1/account/getAppeal`, { params });
    return data;
}
// 提交申诉
export async function postSubmitAppeal(params) {
    let url = '/hey-server/api/v1/account/appeal';
    if(params.fake_user_id){
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + `fake_user_id=${params.fake_user_id}`;
        delete params.fake_user_id;
    }
    if(params.userId){
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + `userId=${params.userId}`;
        delete params.userId;
    }
    if(params['imv.api_st']){
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + `imv.api_st=${params['imv.api_st']}`;
        delete params['imv.api_st'];
    }
    const {data} = await axios.post(url, params);
    return data;
}

/**
 * 相亲房
 */
// 心动榜
export const getRoomRelationHeartRank = GET`/room-server/api/v1/room/blindDate/board/intimacy`;
// 欢喜墙
export const getRoomRelationJoyfulRank = GET`/room-server/api/v1/room/blindDate/board/companion`;

/**
 * 拍卖房
 */
// 房间拍拍榜
export const getAuctionRankInfo = GET`/room-server/api/v1/room/pai/board`;

/**
 * 运营专区
 */
// 获取banner信息
export const getBannerList = GET`/hey-server/api/v2/banner/list`;

/**
 * 校园相关
 */
// 搜索校园列表
export const getSchoolList = GET`/hey-server/api/v1/school/search`;
// 加入学校
export const postApplyJoinSchool = POST`/hey-server/api/v1/school/join`;
// 校园榜单
export async function getSchoolRankList(params) {
    const {data} = await axios.get(`/hey-server/api/v1/school/getBoardInfo`, { params });
    return data;
}
// 获取学校top用户
// export const getSchoolTopUserList = GET`/hey-server/api/v1/school/getSchoolTopMember`;
export async function getSchoolTopUserList(params) {
    const {data} = await axios.get(`/hey-server/api/v1/school/board/getBySchool`, { params });
    return data;
}
// 获取校园用户全部参赛作品
export async function getSchoolUserWorks(params) {
    const {data} = await axios.get(`/hey-server/api/v1/school/board/userVideo`, { params });
    return data;
}
// 绑定校园code
export const postBindSchoolCode = POST`/hey-server/api/v1/school/bindCode`;
// 投票
export const postVoteSchoolWork = POST`/hey-server/api/v1/school/activity/vote`;

// 关注
export const postFollowUser = POST`/hey-server/api/v1/action/follow`;
// 取消关注
export const postUnfollowUser = POST`/hey-server/api/v1/action/unfollow`;

/**
 * 粉丝团
 */
// 获取粉丝团信息
export const getFansInfo = GET`/room-server/api/v1/fanclub/getClubInfo`;
// 获取粉丝团权益列表
export const getFansRightList = GET`/room-server/api/v1/fanclub/getRights`;

// 志愿者申请
export const postApplyVolunteer = POST`/hey-server/api/v1/volunteer/apply`;

/**
 * 其他
 */
// 获取举报信息模版数据
export const getInnerReportInfo = GET`/hey-server/api/v1/inner/page`;
// 想唱歌曲信息
export const postCollectMusic = POST`/hey-server/api/v1/music/collect/submit`;

/**
 * AI歌声重塑
 */
// 获取授权同意书签署状态
export const getAISingingReshape = GET`/hey-server/api/v1/ai/experiment/getAgreeStatus`;
// 签署授权同意书
export const postAgreeAISingingReshape = POST`/hey-server/api/v1/ai/experiment/agree`;

/**
 * 导入作品大众评审
 */
// 获取导入作品大众评审feed
export const getImportPublicAuditFeeds = GET`/hey-server/api/v3/public/audit/import/feeds`;
// 评审结果
export const postSubmitImportPublicAuditResult = POST`/hey-server/api/v3/public/audit/import/result`;

/**
 * 游戏
 */
// 获取游戏配置
export const getGameInfo = GET`/room-server/api/v1/room/cloud/game/getOpConfig`;
// 获取游戏列表
export const getGameList = GET`/room-server/api/v1/room/cloud/game/getGameList`;
// 同意游戏协议
export const postGameAgreement = POST`/room-server/api/v1/room/cloud/game/agreement`;

/**
 * 流量券
 */
// 获取流量券逆袭
export const getTrafficVoucher = GET`/room-server/api/v1/coupon/listBundles`;
// 使用流量券
export const postUseTrafficVoucher = POST`/room-server/api/v1/coupon/expend/doExpend`;
// 转赠流量券
export const postSendTrafficVoucher = POST`/room-server/api/v1/coupon/transfer/doTransfer`;
// 获取转赠候选人
export const getTargetCandidateList = GET`/room-server/api/v1/coupon/transfer/listCandidates`;
// 使用记录
export const getUseHistoryRecord = GET`/room-server/api/v1/coupon/expend/record`;
// 使用效果详情
export const getUseHistoryDetail = GET`/room-server/api/v1/coupon/expend/effect`;
// 停止使用流量券
export const postStopUseCoupon = POST`/room-server/api/v1/coupon/expend/stop`;
// 使用效果预估
export const postVoucherEffectPreview = POST`/room-server/api/v1/coupon/expend/predictEffect`;

/**
 * 绑定歌手主持
 */
// 已绑定歌手主持列表
export const getSingerList = GET`/hey-server/api/v3/room/contract/singer/listSingers`;
// 新增歌手主持绑定
export const postInviteSingerBind = POST`/hey-server/api/v3/room/contract/singer/inviteContract`;
// 解除歌手主持绑定
export const postCancelSingerBind = POST`/hey-server/api/v3/room/contract/singer/cancelContract`;

/**
 * 亲密站
 */
// 房间亲密榜
export const getIntimateList = GET`/room-server/api/v1/room/intimate/board`;
// 推广信息
export const getIntimateIntroInfo = GET`/room-server/api/v3/room/board/intimateBattleRooms`;

/**
 * 哄哄
 */
// 提交话题
export const postSubmitHongHongTopic = POST`/hey-server/api/v1/chatGame/submitTopic`;

/**
 * 反馈与帮助
 */
// 问题反馈首页
export const getHelpPageInfo = GET`/hey-server/api/v1/feedback/pageInfo`;
// 获取tab详情
export const getHelpTabDetail = GET`/hey-server/api/v1/feedback/getTabInfo`;
// 搜索
export const getHelpSearch = GET`/hey-server/api/v1/feedback/search`;
// 换一批常见问题
export const getHelpQuestionRefresh = GET`/hey-server/api/v1/feedback/refreshFaq`;
// 提交意见与建议
export const postSubmitSuggestion = POST`/hey-server/api/v1/feedback/submitAdvice`;
// 提交bug反馈
export const postSubmitFeedback = POST`/hey-server/api/v1/feedback/submitBug`;
// 获取当前反馈状态
export const getFeedbackStatus = GET`/hey-server/api/v1/feedback/getCustomerChatStatus`;
// 获取客服中台跳转url
export const getCustomerServiceUrl = GET`/hey-server/api/v1/feedback/getCscUrl`;

/**
 * 盲盒规则页
 */
export const getBlindBoxInfo = GET`/hey-server/api/v4/randBox/ruleInfo`;

/**
 * 解除青少年模式
 */
// 解除青少年模式状态查询
export const getTeenagerModeInfo = GET`/hey-server/api/v1/teenagerMode/queryReleaseTeenagerModeApply`;
// 解除青少年模式申请
export const postReleaseTeenagerMode = POST`/hey-server/api/v1/teenagerMode/submitReleaseTeenagerModeApply`;

/**
 * 搜索反馈
 */
// 提交反馈
export const postSubmitSearchFeedback = POST`/hey-server/api/v1/feedback/submitSearchFeedback`;
/**
 * 勋章墙
 */
// 获取荣誉勋章墙
export const getHonorMedalList = GET`/hey-server/api/v1/honorMedal/wall`;

/**
 * 新音乐人认证
 */
// 获取音乐人主页认证状态
export const mvpCertificationGetPage = GET`/hey-server/api/v1/mvpCertification/getPage`;
// 获取音乐人认证条件
export const mvpCertificationGetCondition = GET`/hey-server/api/v1/mvpCertification/getCondition`;
// 发起申请
export const mvpCertificationSubmit = POST`/hey-server/api/v1/mvpCertification/submit`;

/**
 * 公会退会相关
 */
// 用户是否满足24小时退会和低营收退会条件
export const getQuitGroupStatUsingGET = GET`/room-server/api/v3/room/room/getQuitGroupStat`;
// 公会退会方式选择
export const postQuitGroup = POST`/room-server/api/v3/room/room/quitGroup`;

/**
 * 查询内容页-单页面
 */
export const getContentPage = async ({ pageName }) => {
    try {
        const { data } = await axios({
            method: 'GET',
            url: `/hey-server/api/v1/contentPage/getPage`,
            params: {
                pageName
            }
        });
        return data;
    } catch (err) {
        console.log(err?.message || err.msg || 'Unknown Error！');
    }
};

/**
 * 个人信息收集清单
 */
// 收集用户个人信息
export const getCollectPersonInfo = GET`/hey-server/api/v1/collect/person/info`;

/**
 * 引力值详情
 */
// 获取引力值详情
export const getScoreHist = GET`/hey-server/api/v1/creatorGrowth/getScoreHist`;

/**
 * 天团广场改版
 */
// 推荐天团列表
export const getRecoBands = GET`/hey-server/api/v3/band/recoBands`;
// 获取天团资源配置信息（包括资源位配置和用户已加入的天团）
export const getResourceConfig = GET`/hey-server/api/v3/band/resourceConfig`;
// 配置天团列表
export const getConfigBands = GET`/hey-server/api/v3/band/configBands`;

